export enum AlertType {
  success = 'primary',
  warning = 'warning',
  danger = 'danger',
}

export default AlertType;
